import React from "react";
import { Button } from "reactstrap";

const TemplateListItem = ({ template, index, onEdit }) => {
  const isEvenRow = index % 2 === 0;

  return (
    <div
      className="d-flex align-items-center px-3 py-3"
      style={{
        backgroundColor: isEvenRow ? "#F7F7F7" : "#FFFFFF",
        fontSize: 14,
      }}
    >
      {/* Name */}
      <div style={{ flex: 2 }}>
        <div style={{ fontWeight: 500 }}>{template.name}</div>
        <div style={{ fontSize: 12, color: "#8A8A8A" }}>
        </div>
      </div>

      {/* Body */}
      <div style={{ flex: 4, fontSize: 13, color: "#555" }}>
        {template.templateBody}
      </div>

      {/* Template ID */}
      <div style={{ flex: 2, fontSize: 12 }}>
        {template.templateId || 'N/A'}
      </div>

      {/* Type */}
      <div style={{ width: 90, fontSize: 13 }}>
        {template.templateType}
      </div>

      {/* Action */}
      <div style={{ width: 90, textAlign: "right" }}>
        <Button
          size="sm"
          color="primary"
          style={{ borderRadius: 20 }}
          onClick={() => onEdit(template)}
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

export default TemplateListItem;